import React from "react"
import styled, {css} from "styled-components"

import {useTheme} from "@irati/ui/src/global/useTheme"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import FlexiPointsIconSrc from "@irati/ui/images/flexi_point.svg"
import RewardPointsIconSrc from "@irati/ui/images/reward_point.svg"

interface CircleProps {
  bgColor: string
  fontSize?: number
}

const Circle = styled.div<CircleProps>`
  height: 16px;
  width: 16px;
  flex:0 0 16px;
  border-radius: 100%;
  padding: 4px 0;
  text-align: center;
  ${({bgColor, theme, fontSize = 8}) => css`
    font-size: ${fontSize}px;
    line-height: ${fontSize}px;
    background-color: ${bgColor};
    color: ${theme.colors.greys.white};
  `}
`
export const GiftCardsIcon = () => {
  const theme = useTheme()
  return (
    <Circle bgColor={theme.colors.utility.success}>
      <Icon icon={IconTypes.reward} size={8} color={theme.colors.greys.white} />
    </Circle>
  )
}
export const DiscountIcon = () => {
  const theme = useTheme()
  return (
    <Circle bgColor={theme.colors.primary1} fontSize={10}>
      %
    </Circle>
  )
}
export const FlexiPointsIcon = () => <img src={FlexiPointsIconSrc} style={{height: 16, width: 16}} alt="Flexi Points icon" />
export const FlexiRewardsIcon = () => <img src={RewardPointsIconSrc} style={{height: 16, width: 16}} alt="Reward Points icon" />
